import React, { forwardRef } from 'react'
import MuiStack, { StackProps } from '@mui/material/Stack'

function _Stack(props: StackProps, ref: React.Ref<HTMLDivElement>) {
  return <MuiStack spacing={1} {...props} ref={ref} />
}

export const Stack = forwardRef(_Stack)
